/**
 * CP-022 — action-specific comment requirement for Closing Package modals.
 * Positive completion actions are optional; negative/corrective actions require a reason.
 */

export type CommentPolicyAction =
  | 'DONE'
  | 'APPROVED'
  | 'RECEIVED'
  | 'FORMED'
  | 'PREPARED'
  | 'DISPATCHED'
  | 'REVISED'
  | 'REJECTED'
  | 'PROBLEM'
  | 'RESEND'
  | 'REVISION';

const COMMENT_REQUIRED_ACTIONS = new Set<CommentPolicyAction>([
  'REJECTED',
  'PROBLEM',
  'RESEND',
  'REVISION',
]);

export function isCommentRequired(action: CommentPolicyAction | string | null | undefined): boolean {
  const key = String(action ?? '').trim().toUpperCase();
  return COMMENT_REQUIRED_ACTIONS.has(key as CommentPolicyAction);
}

export function trimOptionalComment(comment: string | null | undefined): string | undefined {
  const trimmed = String(comment ?? '').trim();
  return trimmed.length > 0 ? trimmed : undefined;
}
